import { render, staticRenderFns } from "./contents.vue?vue&type=template&id=1b7a0ef5"
import script from "./contents.vue?vue&type=script&lang=js"
export * from "./contents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports